import masterCardIcon from "../../../assets/images/Cards-icons/mastercard.svg";
import discoverIcon from "../../../assets/images/Cards-icons/discover.svg";
import visaIcon from "../../../assets/images/Cards-icons/visa.svg";
import americanExpress from "../../../assets/images/Card-icon-parent/american_express.svg";
import otherCardSvg from "../../../assets/images/Cards-icons/otherCard.svg";

export const navigation = ["Header", "Card Activation", "Main Banner", "Feature Section IV", "Feature Section V"];
export const logo_Options = ["Yes", "No"];
export const link_Options = ["Yes", "No"];
export const self_Service_Options = ["Yes", "No"];
export const card_Activation_Options = ["Yes", "No"];
export const video_Link_Options = ["Yes", "No"];
export const add_image_of_mobile_Options = ["Yes", "No"];
export const which_Products = [
  { label: "Credit", value: "Credit" },
  { label: "Debit", value: "Debit" },
  { label: "Prepaid", value: "Prepaid" },
];
export const card_product_images = [
  { label: "i2c to provide images", value: "i2c to provide images" },
  { label: "Use client provided images / icons", value: "Use client provided images / icons" },
];
export const content_blocks_images = [
  { label: "i2c to provide images", value: "i2c to provide images" },
  { label: "Use client provided images / icons", value: "Use client provided images / icons" },
];
export const add_Links_For = [
  { label: "Google Play for Android", value: "Google Play for Android" },
  { label: "App Store for iOS", value: "App Store for iOS" },
]
export const specify_Info = [
  { label: "Issuer Statement", value: "Issuer Statement" },
  { label: "FAQs", value: "FAQs" },
  { label: "Terms and Conditions", value: "Terms and Conditions" },
  { label: "Privacy Policy", value: "Privacy Policy" },
  { label: "Contact Us", value: "Contact Us" },
  { label: "Security Awareness", value: "Security Awareness" },
  { label: "Other", value: "Other" },
]
export const add_section_Landing_Options = ["Yes", "No"];

export const app_Selection_Programs = [
  {
      label: "Discover",
      value: "Discover",
      icon: discoverIcon,
  },
  {
      label: "Visa",
      value: "Visa",
      icon: visaIcon,
  },
  {
      label: "Master Card",
      value: "Master Card",
      icon: masterCardIcon,
  },
  {
      label: "American Express",
      value: "American Express",
      icon: americanExpress,
  },
  {
      label: "Other",
      value: "Other",
      icon: otherCardSvg,
  }
];

export const brand_Colors = ["Brand color scheme", "Custom color scheme"];

export const website_Url = ["i2c standard URL", "Use custom URL"];

export const mobile_App_Publishing = [
  { label: "Client will manage and publish", value: "Client will manage and publish" },
  { label: "i2c Inc. will manage and publish", value: "i2c Inc. will manage and publish" },
  { label: "i2c Inc. to publish using client account", value: "i2c Inc. to publish using client account" },
];

export const languages_Selection = [
  { label: "English", value: "English" },
  { label: "Spanish", value: "Spanish" },
  { label: "Other", value: "Other" },
];
export const other_Languages = ["Japanese", "Chinese", "Portuguese", "French", "Czech","German","Italian","Hebrew","Polish"];
export const publicPageSelection = ["FAQs","Contact","Terms","Privacy Policy"]
export const customMenus = [
  { feature: 'Menu Name', alternativeMethod: '', enabled: false,  deleteable: false}, 
  { feature: 'Menu Name', alternativeMethod: '', enabled: false,  deleteable: true}, 
];
 